import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ApplicationLogo from "./ApplicationLogo";
import { url } from "@/utils";
import { Box, Button, Grid, Modal, TextField, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getAll } from "@/actions/setting.action";
import { MailDto } from "@/data/dtos/mail.dto";
import mailerService from "@/services/mailer.service";
import { setError, setMessage } from "@/actions/message";
import { logger } from "@/lib/default-logger";

interface SuggesTeacherProps {
  name: string;
  surname: string;
  email: string;
  phone?: string;
  suggestedTeacherName: string;
  suggestedTeacherLink: string;
}

interface SuggestCourseProps {
  name: string;
  surname: string;
  email: string;
  phone?: string;
  suggestedCourseName: string;
  suggestedCourseDescription: string;
}

export default function Footer() {
  // const smtpexpressClient = createClient({
  //   projectId: process.env.REACT_APP_EXPRESS_PROJECT_ID ?? "",
  //   projectSecret: process.env.REACT_APP_EXPRESS_PROJECT_SECRET ?? "",
  // });
  const dispatch = useDispatch();
  const { settings, listStatus } = useSelector((state: any) => state.settings);
  const [allSettings, setAllSettings] = useState(settings);
  const [socialLinks, setSocialLinks] = useState<any>([]);
  const currentYear = new Date().getFullYear();

  const [suggestTeacherModalOpen, setSuggestTeacherModalOpen] = useState(false);
  const [suggestCourseModalOpen, setSuggestCourseModalOpen] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [formData, setFormData] = useState<MailDto>({
    subject: "İstek ve Öneri",
    html: "",
    from: {
      name: "",
      address: "",
    },
  });
  const [teacherFormData, setTeacherFormData] = useState<SuggesTeacherProps>({
    name: "",
    surname: "",
    email: "",
    phone: "",
    suggestedTeacherName: "",
    suggestedTeacherLink: "",
  });

  const [courseFormData, setCourseFormData] = useState<SuggestCourseProps>({
    name: "",
    surname: "",
    email: "",
    phone: "",
    suggestedCourseName: "",
    suggestedCourseDescription: "",
  });

  const handleTeacherChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setTeacherFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleCourseChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    setCourseFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const fieldTranslations: Record<string, string> = {
    name: "Ad",
    surname: "Soyad",
    email: "E-Posta",
    phone: "Telefon",
    suggestedTeacherName: "Önerilen Öğretmen Adı",
    suggestedTeacherLink: "Önerilen Öğretmen Linki",
    suggestedCourseName: "Önerilen Kurs Adı",
    suggestedCourseDescription: "Önerilen Kurs Açıklaması",
  };

  const formatMailHTML = (data: Record<string, any>, title: string): string => {
    const rows = Object.entries(data)
      .map(
        ([key, value]) => `
          <tr>
            <td style="padding: 8px; border-bottom: 1px solid #ddd;">
              <strong>${fieldTranslations[key] || key}</strong>
            </td>
            <td style="padding: 8px; border-bottom: 1px solid #ddd;">
              ${value}
            </td>
          </tr>
        `
      )
      .join(""); // Tüm satırları birleştir

    return `
      <div style="font-family: Arial, sans-serif; line-height: 1.5; color: #333;">
        <h2 style="color: #d32f2f;">📌${title}</h2>
        <table style="width: 100%; border-collapse: collapse;">
          <tr>
            <th style="text-align: left; padding: 8px; background: #f4f4f4;">Alan</th>
            <th style="text-align: left; padding: 8px; background: #f4f4f4;">Değer</th>
          </tr>
          ${rows}
        </table>
        <p style="margin-top: 20px; color: #555;">Bu form kullanıcının girdiği bilgilerle oluşturulmuştur.</p>
      </div>
    `;
  };

  const handleTeacherSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    logger.log("Teacher Suggestion Data:", teacherFormData);
    const mailData: MailDto = {
      subject: "Öğretmen Öneri",
      html: formatMailHTML(teacherFormData, "Öğretmen Öneri"),
      from: {
        name: teacherFormData.name,
        address: teacherFormData.email,
      },
    };

    try {
      const response = await mailerService.sendMail(mailData);

      if (response?.status === 201) {
        dispatch(setMessage("Mail başarıyla gönderildi!", 5000) as any);
      } else {
        dispatch(setError("Mail gönderilirken bir hata oluştu."));
      }
    } catch (error: any) {
      alert("Bağlantı hatası: " + error?.message);
    }
    setSuggestTeacherModalOpen(false);
    setTeacherFormData({
      name: "",
      surname: "",
      email: "",
      phone: "",
      suggestedTeacherName: "",
      suggestedTeacherLink: "",
    });
  };

  const handleCourseSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    logger.log("Course Suggestion Data:", courseFormData);
    const mailData: MailDto = {
      subject: "Kurs Öneri",
      html: formatMailHTML(courseFormData, "Kurs Öneri"),
      from: {
        name: courseFormData.name,
        address: courseFormData.email,
      },
    };
    try {
      const response = await mailerService.sendMail(mailData);

      if (response?.status === 201) {
        dispatch(setMessage("Mail başarıyla gönderildi!", 5000) as any);
      } else {
        dispatch(setError("Mail gönderilirken bir hata oluştu."));
      }
    } catch (error: any) {
      alert("Bağlantı hatası: " + error?.message);
    }
    setSuggestCourseModalOpen(false);
    setCourseFormData({
      name: "",
      surname: "",
      email: "",
      phone: "",
      suggestedCourseName: "",
      suggestedCourseDescription: "",
    });
  };

  const handleSubmitRequest = async (event: React.FormEvent) => {
    event.preventDefault();
    const mailData: MailDto = {
      subject: "İstek ve Öneri",
      html: formData.html,
      from: {
        name: formData.from?.name!,
        address: formData.from?.address!,
      },
    };
    try {
      const response = await mailerService.sendMail(mailData);

      if (response?.status === 201) {
        dispatch(setMessage("Mail başarıyla gönderildi!", 5000) as any);
      } else {
        dispatch(setError("Mail gönderilirken bir hata oluştu."));
      }
    } catch (error: any) {
      alert("Bağlantı hatası: " + error?.message);
    }
    setIsOpen(false);
    setFormData({
      subject: "İstek ve Öneri",
      html: "",
      from: {
        name: "",
        address: "",
      },
    });
  };

  useEffect(() => {
    if (listStatus === "idle") {
      dispatch(getAll() as any);
    }
  }, [listStatus, dispatch]);

  useEffect(() => {
    const socialLinksSetting = settings.find(
      (setting: any) => setting.key === "socialLinks"
    );
    if (socialLinksSetting) {
      setAllSettings(settings);
      setSocialLinks(socialLinksSetting.value);
    }
  }, [settings]);

  return (
    <footer className="bg-white border-t shadow">
      <Modal open={suggestTeacherModalOpen}>
        <Box
          sx={{
            maxWidth: 600,
            mx: "auto",
            mt: 5,
            backgroundColor: "white",
            borderRadius: "8px",
          }}
        >
          <Box mb={4} p={3} boxShadow={3}>
            <Typography variant="h5" mb={2} textAlign="center">
              Eğitmen Öner
            </Typography>
            <form onSubmit={handleTeacherSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Adınız"
                    name="name"
                    value={teacherFormData.name}
                    onChange={handleTeacherChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Soyadınız"
                    name="surname"
                    value={teacherFormData.surname}
                    onChange={handleTeacherChange}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="E-Posta Adresiniz"
                    name="email"
                    type="email"
                    value={teacherFormData.email}
                    onChange={handleTeacherChange}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Telefon Numaranız (Opsiyonel)"
                    name="phone"
                    value={teacherFormData.phone}
                    onChange={handleTeacherChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Önerilen Eğitmen Adı"
                    name="suggestedTeacherName"
                    value={teacherFormData.suggestedTeacherName}
                    onChange={handleTeacherChange}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Eğitmen Hakkında Bağlantı Adresi (Linkedin, Twitter, vb.)"
                    name="suggestedTeacherLink"
                    value={teacherFormData.suggestedTeacherLink}
                    onChange={handleTeacherChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sx={{ display: "flex", gap: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                  >
                    Eğİtmen Öner!
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="error"
                    fullWidth
                    onClick={() => setSuggestTeacherModalOpen(false)}
                  >
                    Vazgeç
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
      </Modal>
      <Modal open={suggestCourseModalOpen}>
        <Box
          sx={{
            maxWidth: 600,
            mx: "auto",
            mt: 5,
            backgroundColor: "white",
            borderRadius: "8px",
          }}
        >
          <Box p={3} boxShadow={3}>
            <Typography variant="h5" mb={2} textAlign="center">
              Atölye Öner
            </Typography>
            <form onSubmit={handleCourseSubmit}>
              <Grid container spacing={2}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Adınız"
                    name="name"
                    value={courseFormData.name}
                    onChange={handleCourseChange}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    fullWidth
                    label="Soyadınız"
                    name="surname"
                    value={courseFormData.surname}
                    onChange={handleCourseChange}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="E-Posta Adresiniz"
                    name="email"
                    type="email"
                    value={courseFormData.email}
                    onChange={handleCourseChange}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Telefon numaranız (Opsiyonel)"
                    name="phone"
                    value={courseFormData.phone}
                    onChange={handleCourseChange}
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Önerilen Atölye Adı"
                    name="suggestedCourseName"
                    value={courseFormData.suggestedCourseName}
                    onChange={handleCourseChange}
                    required
                  />
                </Grid>
                <Grid item xs={12}>
                  <TextField
                    fullWidth
                    label="Önerilen Atölye Açıklaması"
                    name="suggestedCourseDescription"
                    value={courseFormData.suggestedCourseDescription}
                    onChange={handleCourseChange}
                    multiline
                    rows={4}
                    required
                  />
                </Grid>
                <Grid item xs={12} sx={{ display: "flex", gap: 2 }}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    fullWidth
                  >
                    ATÖLYE ÖNER!
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="error"
                    fullWidth
                    onClick={() => setSuggestCourseModalOpen(false)}
                  >
                    Vazgeç
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Box>
      </Modal>
      <Modal open={isOpen}>
        <Box
          sx={{
            maxWidth: 600,
            mx: "auto",
            mt: 5,
            backgroundColor: "white",
            borderRadius: "8px",
          }}
        >
          <form className="space-y-4 p-4" onSubmit={handleSubmitRequest}>
            <div>
              <label
                htmlFor="name"
                className="block text-sm font-medium text-secondary"
              >
                Adınız
              </label>
              <input
                type="text"
                name="from.name"
                value={formData.from?.name}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    from: {
                      ...formData.from,
                      name: e.target.value,
                      address: formData.from?.address ?? "",
                    },
                  })
                }
                className="mt-1 block w-full p-2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                placeholder="Adınızı girin"
                required
              />
            </div>
            <div>
              <label
                htmlFor="email"
                className="block text-sm  font-medium text-secondary"
              >
                E-posta
              </label>
              <input
                type="email"
                name="address"
                value={formData.from?.address}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    from: {
                      ...formData.from,
                      address: e.target.value,
                      name: formData.from?.name ?? "",
                    },
                  })
                }
                className="mt-1 block w-full  p-2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                placeholder="E-posta adresinizi girin"
                required
              />
            </div>
            <div>
              <label
                htmlFor="message"
                className="block text-sm font-medium text-secondary"
              >
                Mesajınız
              </label>
              <textarea
                name="html"
                id="html"
                value={formData.html}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    html: e.target.value,
                  })
                }
                rows={4}
                className="mt-1 block w-full p-2 rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500"
                placeholder="Mesajınızı yazın"
                required
              ></textarea>
            </div>
            <div className="flex gap-2 justify-between">
              <Button
                type="submit"
                variant="contained"
                color="primary"
                fullWidth
              >
                GÖNDER
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="error"
                fullWidth
                onClick={() => setIsOpen(false)}
              >
                Vazgeç
              </Button>
            </div>
          </form>
        </Box>
      </Modal>
      <div className="space-y-8 px-4 pt-8 sm:px-6 lg:space-y-16 lg:px-8">
        <div className="mx-auto max-w-screen-xl ">
          <div className="sm:flex sm:items-center sm:justify-between">
            <div className="text-teal-600" style={{ width: "15rem" }}></div>

            <ul className="mt-8 flex justify-start gap-6 sm:mt-0 sm:justify-end pe-10">
              {socialLinks.map((link) => (
                <Link
                  key={link.name}
                  to={link.href}
                  rel="noreferrer"
                  target="_blank"
                  className="text-orange-50 transition hover:opacity-75"
                >
                  <span className="sr-only">{link.name}</span>
                  <div dangerouslySetInnerHTML={{ __html: link.icon }}></div>
                </Link>
              ))}
            </ul>
          </div>

          <div
            className="sm:flex sm:items-center mt-0 justify-end"
            style={{ marginTop: "0px" }}
          >
            <div className="flex justify-between w-full items-center">
              <div className="flex gap-2 hover:scale-105">
                <ApplicationLogo className="w-48" />
              </div>
              <div className="flex gap-2 hover:scale-105">
                <Link target="_blank" to="https://saydakitap.com/">
                  <img src="/logo2.jpg" alt="logo" className="w-64" />
                </Link>
              </div>
            </div>
          </div>

          <div className="grid px-8 grid-cols-1 gap-8 border-t border-gray-100 pt-8 sm:grid-cols-2 lg:grid-cols-4 lg:pt-16">
            <div className="">
              <p className="font-bold text-gray-900">Hizmetler</p>

              <ul className="mt-6 space-y-4 text-sm ">
                <li>
                  <Link
                    to={url("Home.Workshops")}
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Atölyeler
                  </Link>
                </li>

                <li>
                  <Link
                    to={url("Home.About.Fictional-Workshop")}
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Kurgusal Etkinlik
                  </Link>
                </li>

                <li>
                  <Link
                    to="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Bireysel Atölyeler
                  </Link>
                </li>

                <li>
                  <Link
                    to="https://saymedya.com/"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Marka ve İletişim Danışmanlığı
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://saydakitap.com/"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Yayıncılık
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.saymedya.com/hizmet-alanlar%C4%B1"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Danışmanlık
                  </Link>
                </li>
                <li>
                  <Link
                    to="https://www.saymedya.com/hizmet-alanlar%C4%B1"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Etkinlik ve Organizasyon
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <p className="font-bold text-gray-900">İstek Ve Öneriler</p>

              <ul className="mt-6 space-y-4 text-sm">
                <li>
                  <button
                    onClick={() =>
                      setSuggestCourseModalOpen(!suggestCourseModalOpen)
                    }
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Atölye Öner
                  </button>
                </li>

                <li>
                  <button
                    onClick={() =>
                      setSuggestTeacherModalOpen(!suggestTeacherModalOpen)
                    }
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Eğitmen Öner
                  </button>
                </li>

                <li>
                  <button
                    className="text-gray-700 transition hover:opacity-75"
                    onClick={() => setIsOpen(!isOpen)}
                  >
                    İstek ve Öneri
                  </button>
                </li>
              </ul>
            </div>

            <div>
              <p className="font-bold text-gray-900">Yararlı Linkler</p>

              <ul className="mt-6 space-y-4 text-sm">
                <li>
                  <Link
                    to={url("Home.Contact")}
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    İletişim
                  </Link>
                </li>

                <li>
                  <Link
                    to={url("Home.Contact")}
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    SSS
                  </Link>
                </li>

                <li>
                  <Link
                    to="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Canlı Sohbet
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <p className="font-bold text-gray-900">Yasal Bilgiler</p>

              <ul className="mt-6 space-y-4 text-sm">
                <li>
                  <Link
                    to={url("Policies.Return-Policy")}
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    İade Politikası
                  </Link>
                </li>

                <li>
                  <Link
                    to={url("Policies.Secret-Policy")}
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Gizlilik Politikası
                  </Link>
                </li>

                <li>
                  <Link
                    to="#"
                    className="text-gray-700 transition hover:opacity-75"
                  >
                    Müşteri Memnuniyetleri
                  </Link>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="flex flex-col items-center gap-6 bg-gray-50 py-6">
          {/* Ödeme Yöntemleri */}
          <div className="flex flex-wrap justify-center gap-4">
            <img
              loading="lazy"
              src="/assets/MasterCard_Logo.svg"
              alt="MasterCard"
              className="h-8 w-auto"
            />
            <img
              loading="lazy"
              src="/assets/Visa_2021.png"
              alt="Visa"
              className="h-8 w-auto"
            />
            <img
              loading="lazy"
              src="/assets/american_express.png"
              alt="American Express"
              className="h-8 w-auto"
            />

            <img
              loading="lazy"
              src="/assets/troy-logo-sloganli-01.png"
              alt="Troy"
              className="h-8 w-auto"
            />
          </div>

          {/* Güvenlik Bilgisi */}
          <div className="flex flex-wrap justify-center items-center gap-4">
            <img
              loading="lazy"
              src="/assets/SecureShopping.webp"
              alt="Güvenli Alışveriş"
              className="h-8 w-auto"
            />
            <img
              loading="lazy"
              src="/assets/PCI_DSS.webp"
              alt="PCI DSS"
              className="h-8 w-auto"
            />
          </div>
        </div>

        <div className="mx-auto max-w-screen-xl ">
          <p className="text-center font-body ">
            <span className=" text-secondary">
              Say&Co, Say Medya Ticaret Ltd. Sti'ye ait bir markadır. Her
              hakkı saklıdır.
            </span>
          </p>

          <p className="text-xs text-gray-500">
            &copy; {currentYear} Rovet Veri Denizi Yazılım LTD. ŞTİ. Bütün
            Hakları Saklıdır.
          </p>
        </div>
      </div>
    </footer>
  );
}
